import { render, staticRenderFns } from "./CaseOverviewFacts.vue?vue&type=template&id=14e00956"
import script from "./CaseOverviewFacts.vue?vue&type=script&lang=js"
export * from "./CaseOverviewFacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports